import { Link } from "react-router-dom";
import type { UserType } from "../../types";

function Welcome(props: { users: UserType[]; owner: UserType }) {
  const { users, owner } = props;

  const handleFeedback = () => {
    window.Telegram.WebApp.openTelegramLink("https://t.me/dshemigon");
    // Implement the logic for writing a message to the user
  };

  if (!owner) {
    return;
  }

  return (
    <div className="flex flex-col w-full">
      {/* Main content container */}
      <div className="p-4">
        {/* Header with logo and title */}
        <div className="flex gap-2 mb-6 items-center justify-center">
          <div className="rounded-full flex items-center justify-center">
            <img
              src="/miniapp/logo-vertical-rus.svg"
              alt="Logo"
              className="w-24 h-24"
            />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-black leading-tight">
              Сообщество
              <br />
              выпускников
              <br />
              EMBA / MBA
            </h1>
          </div>
        </div>

        {/* Circular profile arrangement */}
        <div className="relative w-48 h-48 mx-auto mb-6">
          {/* Center large circle */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-20 h-20 bg-gray-100 rounded-full overflow-hidden">
            <Link to={`/users/${owner.telegram_id}/details`}>
              <img
                src={`/api/users/${owner.telegram_id}/avatar`}
                className="w-full h-full object-cover"
              />
            </Link>
          </div>

          {/* Surrounding smaller circles */}
          {users.map((otherUser, index) => {
            const angle = (index * 45 - 90) * (Math.PI / 180); // 45 degrees apart, starting from 12 o'clock
            const radius = 75; // Distance from center
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;

            return (
              <div
                key={index}
                className="absolute w-10 h-10 bg-gray-100 rounded-full overflow-hidden"
                style={{
                  left: `calc(50% + ${x}px - 20px)`,
                  top: `calc(50% + ${y}px - 20px)`,
                }}
              >
                <Link to={`/users/${otherUser.telegram_id}/details`}>
                  <img
                    src={`/api/users/${otherUser.telegram_id}/avatar`}
                    className="w-full h-full object-cover"
                  />
                </Link>
              </div>
            );
          })}
        </div>

        {/* Description text */}
        <p className="text-black font-medium mb-4 text-center">
          Вы в Сообществе. Наши возможности:
        </p>

        {/* Feature cards */}
        <div className="grid grid-cols-2 gap-3 mb-3">
          <Link to="/search">
            <div className="aspect-square bg-gray-100 flex flex-col items-center justify-center p-3 hover:opacity-80 transition-opacity">
              <span className="text-black text-base font-semibold text-center mb-2">
                Поиск выпускников
              </span>
              <span className="text-gray-600 text-xs text-center">
                По компаниям, экспертизе, индустриям, функциям и хобби
              </span>
            </div>
          </Link>
          <Link to="/random-coffee">
            <div className="aspect-square bg-gray-100 flex flex-col items-center justify-center p-3">
              <span className="text-black text-base font-semibold text-center mb-2">
                Рандом-кофе
              </span>
              <span className="text-gray-600 text-xs text-center">
                Еженедельные встречи со случайным выпускником
              </span>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <Link to={`/users/${owner.telegram_id}/details`}>
            <div className="aspect-square bg-gray-100 flex flex-col items-center justify-center p-3 hover:opacity-80 transition-opacity">
              <span className="text-black text-base font-semibold text-center mb-2">
                Ваш профиль
              </span>
              <span className="text-gray-600 text-xs text-center">
                Как видят вас другие выпускники
              </span>
            </div>
          </Link>
          <div
            onClick={handleFeedback}
            className="aspect-square bg-gray-100 flex flex-col items-center justify-center p-3 hover:opacity-80 transition-opacity cursor-pointer"
          >
            <span className="text-black text-base font-semibold text-center mb-2">
              Обратная связь
            </span>
            <span className="text-gray-600 text-xs text-center">
              Предложите идею развития сообщества
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Welcome };
